// 調證用戶資訊 - 繁體中文
export default {
  balance: {
    available: "可用餘額",
    accountAssets: "賬戶總資產預覽(USDT)",
  },
  basicInfo: {
    title: "基礎資訊",
    expandAll: "展開全部",
    collapseAll: "收起全部",
  },
  character: {
    addCharacter: "添加人物",
    viewDetails: "查看詳情",
    syncFailed: "人物資訊同步失敗",
  },
  fields: {
    name: "[姓名]",
    userId: "[用戶ID]",
    username: "[用戶名]",
    nationality: "[國籍]",
    idNumber: "[證件號]",
    homePlace: "[籍貫]",
    sex: "[性別]",
    phone: "[手機號]",
    email: "[郵箱]",
    registerTime: "[註冊時間]",
    relatedCase: "[關聯案件]",
    note: "[備註]",
    deviceId: "[設備ID]",
    firstUseTime: "[首次使用時間]",
    analysisId: "[分析ID]",
    platform: "[平台]",
    bindPhoneTime: "[綁定手機時間]",
    paymentInfo: "[收款資訊]",
    walletAddress: "[錢包地址]",
    usedAddress: "[使用過的地址]",
    watchedAddress: "[觀察過的地址]",
    walletAccount: "[錢包賬戶]",
  },
  common: {
    none: "--",
    yes: "有",
    no: "無",
    noBank: "暫無查詢到相關銀行",
    wechat: "微信",
    alipay: "支付寶",
    moreData: "條數據，加載更多",
    collapse: "收起",
  },
};
